/** Страница нового пароля: подтверждает код из письма и восстанавливает доступ. */
import { useForm } from "@tanstack/react-form";
import { Link, useNavigate } from "react-router-dom";
import { z } from "zod";
import { apiHooks } from "@/api";
import { routerPaths } from "@/app/routerPaths";
import { UIKit } from "@/shared/ui";

const resetPasswordSchema = z.object({
	code: z.string().min(1, "Введите код"),
	email: z
		.string()
		.min(1, "Введите электронную почту")
		.email("Введите корректную электронную почту"),
	newPassword: z.string().min(6, "Пароль должен содержать минимум 6 символов"),
});

export const ResetPasswordPage = () => {
	const navigate = useNavigate();
	const resetPasswordApi = apiHooks.auth.useResetPassword();
	const form = useForm({
		defaultValues: { code: "", email: "", newPassword: "" },
		validators: { onChange: resetPasswordSchema },
		onSubmit: async ({ value }) => {
			const response = await resetPasswordApi.execute(value);
			if (response.error !== null) return;
			await navigate(routerPaths.login);
		},
	});

	return (
		<div className="flex flex-1 items-center justify-center overflow-y-auto px-5 py-10">
			<form className="w-full max-w-sm" action={() => form.handleSubmit()}>
				<UIKit.Text className="mb-2 font-medium text-accent">GRID PLANNER</UIKit.Text>
				<UIKit.Text size="xl">Новый пароль</UIKit.Text>
				<div className="mt-7 space-y-4">
					<UIKit.FormField form={form} name="email">
						{(field) => (
							<UIKit.TextInput
								label="Электронная почта"
								type="email"
								value={field.state.value}
								onChange={field.handleChange}
								autoComplete="email"
							/>
						)}
					</UIKit.FormField>
					<UIKit.FormField form={form} name="code">
						{(field) => (
							<UIKit.TextInput
								label="Код из письма"
								value={field.state.value}
								onChange={field.handleChange}
								autoComplete="one-time-code"
							/>
						)}
					</UIKit.FormField>
					<UIKit.FormField form={form} name="newPassword">
						{(field) => (
							<UIKit.TextInput
								label="Новый пароль"
								type="password"
								value={field.state.value}
								onChange={field.handleChange}
								autoComplete="new-password"
							/>
						)}
					</UIKit.FormField>
				</div>
				<UIKit.Button
					className="mt-6 w-full border-accent bg-accent py-3 text-sm font-medium text-overlay-ink hover:border-accent-hover hover:bg-accent-hover"
					type="submit"
					disabled={resetPasswordApi.isPending}
				>
					{resetPasswordApi.isPending ? "Сохраняем..." : "Сохранить пароль"}
				</UIKit.Button>
				<UIKit.Text className="mt-5 text-center text-ink">
					<Link className="font-medium text-accent hover:underline" to={routerPaths.passwordReset}>
						Запросить новый код
					</Link>
				</UIKit.Text>
			</form>
		</div>
	);
};
